<template>
    <div>
		<div class="mx-n3 mb-3">
			<legend class="font-weight-semibold h5 px-3">
				<i class="fa-solid fa-lock-keyhole mr-2"></i>{{ $t("Verification") }}
			</legend>
		</div>

		<div class="px-md-2">
			<div class="mb-2">{{ $t('Step 1 : Please select verification method') }}</div>
			<div class="form-group">
				<ul class="list-group list-group-flush py-0">
					<li @click="select(1)" :class="[ $parent.verifyMethodId == 1 ? 'selected-item':'']" class="align-items-center list-group-item list-group-item-action  border rounded-6px cursor-pointer px-4 mb-3">
						<div class="d-flex align-items-center">
							<i class="far fa-envelope text-primary h3 mb-0 mr-3 "></i>
							<div>
								<div class="h6 font-weight-semibold">
									{{$t('Verification code via email')}}
								</div>
								<div class="text-secondary mt-n1">
									{{$parent.userData.email}}
								</div>
							</div>
						</div>
					</li>
					<li @click="select(2)" :class="[ $parent.verifyMethodId == 2 ? 'selected-item':'']" class="align-items-center list-group-item list-group-item-action  border rounded-6px cursor-pointer px-4 mb-3">
						<div class="d-flex align-items-center">
							<i class="fa-regular fa-comment-sms text-primary h3 mb-0 mr-3"></i>
							<div>
								<div class="h6 font-weight-semibold">
									{{$t('Verification code via SMS')}}
								</div>
								<div class="text-secondary mt-n1">
									<span style="font-weight: 500;font-size: 18px; margin-right:1px; letter-spacing: 0.10em;" >
										··· ···
									</span>
									{{$parent.userData.mobile.substr($parent.userData.mobile.length - 4)}}
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
			

		</div> 
       
    </div>
</template>
<script>

export default {
	name: "Verification",
	components: {
	},
	data() {
		return{ 
		};
		
	},
	methods: {
		select(id){
			this.$parent.verifyMethodId = id;
		}
	},
	
};

</script>
<style scoped>
.list-group-item-action:focus, .list-group-item-action:hover {
    z-index: 1;
    color: #333;
    text-decoration: none;
    background-color: #fafafa;
}
.list-group-item-action.selected-item,
.list-group-item-action.selected-item:hover{ background-color: #F7FBFF !important; border-color: #2196F3 !important;}
</style>



// WEBPACK FOOTER //
// src/components/central/account/security/Verification.vue